import React from 'react';

const PaginationList = ({numberOfPages, currentPageNumber, onPageChange, onPrev, onNext}) => {
    if (numberOfPages <= 1) {
        return null;
    } else {
        const pageNumbers = getPageNumbers(numberOfPages, currentPageNumber);
        const pages = pageNumbers.map((number, i) =>
            <PaginationItem
                handlePageChange={onPageChange}
                key={i}
                pageNumber={number}
                currentPageNumber={currentPageNumber}
            />
        );

        return (
            <ul className="pager" aria-controls="productsList">
                {currentPageNumber > 1 &&
                <li className="prev"><a href="#" onClick={onPrev}>Previous</a></li>
                }
                {pages}
                {currentPageNumber < numberOfPages &&
                <li className="next"><a href="#" onClick={onNext}>Next</a></li>
                }
            </ul>
        );
    }
};

const PaginationItem = ({pageNumber, currentPageNumber, handlePageChange}) => {
    let item;

    if (pageNumber === currentPageNumber) {
        item = (
            <li className="current" onClick={(e) => e.preventDefault()}>
                <a href="#">
                    {pageNumber}
                </a>
            </li>
        );
    } else if(pageNumber === "...") {
        item = (
            <li className="dots">
                <a href="#" onClick={(e) => e.preventDefault()}>
                    {pageNumber}
                </a>
            </li>
        );
    } else if (pageNumber !== currentPageNumber) {
        item = (
            <li>
                <a href="#" onClick={() => handlePageChange(pageNumber)}>
                    {pageNumber}
                </a>
            </li>
        );
    } else {
        item = null;
    }

    return item;
};

function getPageNumbers(numberOfPages, currentPageNumber) {
    const
        firstPageNumber = 1,
        placeholderForNotVisibleNumbers = '...',
        lastPageNumber = numberOfPages,
        maxNumberOfConsecutivePages = 5,
        maxPositionOfActiveElement = maxNumberOfConsecutivePages - 1;

    let pageNumbers = [];

    if (numberOfPages <= 1) {
        return null;

    } else if (numberOfPages <= maxNumberOfConsecutivePages) {
        pageNumbers = createPageNumbers(firstPageNumber, lastPageNumber);

    } else if (numberOfPages > maxNumberOfConsecutivePages) {

        if (currentPageNumber < maxPositionOfActiveElement) {
            pageNumbers = [
                ...createPageNumbers(firstPageNumber, maxNumberOfConsecutivePages),
                placeholderForNotVisibleNumbers,
                lastPageNumber
            ];
        }

        if ((currentPageNumber >= maxPositionOfActiveElement) && (currentPageNumber <= lastPageNumber - maxPositionOfActiveElement)) {
            pageNumbers = [
                firstPageNumber,
                placeholderForNotVisibleNumbers,
                currentPageNumber - 1,
                currentPageNumber,
                currentPageNumber + 1,
                placeholderForNotVisibleNumbers,
                lastPageNumber];
        }
        if ((currentPageNumber >= maxPositionOfActiveElement) && (currentPageNumber > lastPageNumber - maxPositionOfActiveElement)) {
            pageNumbers = [
                firstPageNumber,
                placeholderForNotVisibleNumbers,
                ...createPageNumbers(lastPageNumber - maxPositionOfActiveElement, lastPageNumber)
            ];
        }
    }

    return pageNumbers;
}

function createPageNumbers(startPageNumber, endPageNumber) {
    const numberOfPages = endPageNumber - startPageNumber;
    let pageNumbers = [],
        currentPageNumber = startPageNumber;

    for (let i = 0; i <= numberOfPages; i++) {
        pageNumbers[i] = currentPageNumber;
        currentPageNumber++;
    }

    return pageNumbers;
}

export default PaginationList;